import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NavController, NavParams, ToastController, ModalController, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MdaProvider } from "src/app/services/mda/mda";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-mda-encontro-avaliacao",
  templateUrl: "./mda-encontro-avaliacao.page.html",
  styleUrls: ["./mda-encontro-avaliacao.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, ReactiveFormsModule],
})
export class MdaEncontroAvaliacaoPage implements OnInit {
  mda: any = {};
  validations_form: FormGroup;
  isDiscipulador = false;
  qualidadeDiscipulo: number;
  estrelas = [0, 1, 2];
  mapaQualidade: Record<number, string> = {
    0: this.translate.instant("Insatisfatório"),
    1: this.translate.instant("Mediano"),
    2: this.translate.instant("Excelente"),
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public mdaProvider: MdaProvider,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private translate: TranslateService
  ) {
    this.mda = this.navParams.get("mda");
    this.isDiscipulador = this.navParams.get("isDiscipulador");
    this.qualidadeDiscipulo = this.navParams.get("qualidadeDiscipulo") ?? 1;

    this.validations_form = this.formBuilder.group({
      qualidadeDiscipulo: new FormControl(this.isDiscipulador ? 0 : this.mda.qualidadeDiscipulo, Validators.required),
      qualidadeDiscipulador: new FormControl(this.qualidadeDiscipulo, Validators.nullValidator),
    });
  }

  ngOnInit() {
    this.qualidadeDiscipulo = this.navParams.get("qualidadeDiscipulo") ?? 1;
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  avaliacao(index: number) {
    this.qualidadeDiscipulo = index;

    if (this.isDiscipulador) {
      this.validations_form.get("qualidadeDiscipulador")?.setValue(index);
    } else {
      this.validations_form.get("qualidadeDiscipulo")?.setValue(index);
    }
  }

  onSubmit(avaliacao: any) {
    if (this.isDiscipulador) {
      this.modalCtrl.dismiss(avaliacao);
      return;
    }

    this.mda.qualidadeDiscipulo = avaliacao.qualidadeDiscipulo;

    this.mdaProvider.salvarQualidadeDiscipulado(this.mda).subscribe(async () => {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("Encontro avaliado com sucesso!"),
        duration: 3000,
      });

      toast.present();
      this.modalCtrl.dismiss(this.mda);
    });
  }

  get qualidadeTexto(): string {
    return this.mapaQualidade[this.qualidadeDiscipulo] || "";
  }

  getStatusText(status: number): string {
    switch (status) {
      case 0:
        return this.translate.instant("Encontro em Aberto");
      case 1:
        return this.translate.instant("Encontro realizado");
      case 2:
        return this.translate.instant("Encontro não Realizado");
      case 3:
        return this.translate.instant("Encontro Desmarcado");
      default:
        return this.translate.instant("Não Informado");
    }
  }
}
